var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightSideNavMailzzyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 40,
    viewBox: "0 0 172 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3201 6.95634C10.3201 6.95634 7.09509 7.08967 7.13809 10.2897C7.18109 13.4897 7.13809 26.3786 7.13809 26.3786C7.13809 26.3786 7.97659 29.9119 10.9651 30.0008C13.9536 30.0897 31.6266 30.0008 31.6266 30.0008C31.6266 30.0008 34.8301 29.623 35.4536 26.2008V9.35634C35.4536 9.35634 35.2601 6.97856 32.3361 7.17856C32.3361 7.17856 35.2601 3.57856 40.3556 5.64523C40.3556 5.64523 41.3661 7.53411 41.3661 10.8452C41.3661 14.1563 41.3661 26.3341 41.3661 26.3341C41.3661 26.3341 40.7426 35.4452 31.7126 36.1341H9.39559C9.39559 36.1341 2.06409 34.9341 1.22559 26.8674C1.22559 25.7563 1.22559 24.6452 1.22559 23.5341C1.22559 21.1786 1.22559 18.823 1.22559 16.4452C1.22559 14.3119 1.22559 12.1786 1.22559 10.023C1.22559 9.46745 1.18259 8.84523 1.26859 8.26745C1.37609 7.66745 1.67709 7.08967 2.02109 6.57856C2.66609 5.57856 3.65509 4.80078 4.85909 4.80078C5.24609 4.80078 5.61159 4.97856 5.99859 5.00078C10.0836 5.24523 10.3201 6.95634 10.3201 6.95634Z",
    fill: "url(#paint0_linear_15666_2579)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20434 11.8691V9.06914C1.20434 9.06914 0.924844 6.0247 4.49384 4.89136C8.06284 3.75803 10.3203 6.95803 10.3203 6.95803C10.3203 6.95803 7.52534 6.93581 7.15984 9.86914V11.8691",
    fill: "url(#paint1_linear_15666_2579)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95703 6.75569C1.95703 6.75569 4.45103 1.24458 14.255 9.91124C14.255 9.91124 17.6735 12.2668 21.307 7.77791L15.0505 2.97791C15.0505 2.97791 7.09553 -3.15542 1.95703 6.75569Z",
    fill: "url(#paint2_linear_15666_2579)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4534 11.8894V9.35608C35.4534 9.35608 35.3029 6.91163 32.3359 7.1783C32.3359 7.1783 35.7329 3.71163 40.3554 5.64497C40.3554 5.64497 41.3659 7.1783 41.3659 11.8894",
    fill: "url(#paint3_linear_15666_2579)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8242 9.6011C13.8242 9.6011 16.1247 10.8233 20.3817 8.46777C24.7247 5.37888 29.2827 0.423326 33.6042 1.17888C37.9257 1.93444 40.3767 5.62333 40.3767 5.62333C40.3767 5.62333 35.9262 4.48999 32.9162 6.75666C29.9062 9.02333 29.8847 9.02333 29.8847 9.02333L21.3062 15.49L13.8242 9.6011Z",
    fill: "#C11D85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.287 8.60156C105.265 8.60156 105.244 8.60156 105.201 8.60156C105.179 8.60156 105.158 8.62378 105.158 8.62378C103.567 9.49045 101.976 10.3571 100.385 11.2016C100.32 11.246 100.277 11.2905 100.277 11.3793C100.277 11.4682 100.342 11.5127 100.406 11.5349C100.836 11.6905 101.245 11.8238 101.675 11.9793C101.718 12.0016 101.739 11.9793 101.782 11.9571C102.685 11.1571 103.588 10.3571 104.491 9.55712L104.513 9.5349C103.803 10.4238 103.072 11.3349 102.363 12.2238C103.115 12.4905 103.868 12.7571 104.599 13.0238C104.706 13.0682 104.792 13.0016 104.814 12.8905C104.857 12.5793 104.9 12.246 104.943 11.9349C105.007 11.4905 105.072 11.0238 105.136 10.5793C105.201 10.0905 105.265 9.62378 105.351 9.1349C105.373 9.02378 105.394 8.9349 105.394 8.82378C105.394 8.80156 105.394 8.75712 105.394 8.7349C105.394 8.66823 105.351 8.62378 105.287 8.60156Z",
    fill: "#ACC737"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.148 12.5339C102.148 12.8673 102.148 13.2006 102.148 13.5339C102.148 13.5562 102.148 13.6006 102.17 13.6228C102.234 13.7339 102.363 13.7339 102.449 13.6451C102.535 13.5339 102.6 13.4228 102.686 13.3117C102.793 13.1562 102.901 13.0006 103.03 12.8228C102.729 12.7117 102.449 12.6228 102.17 12.5117C102.148 12.5117 102.148 12.5117 102.148 12.5339Z",
    fill: "#ACC737"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.317 31.6453L69.102 15.9342L62.1145 28.6009H59.0185L52.16 15.9342L51.902 31.6453H47.043L47.8385 5.44531H50.9775L60.5665 22.6675L70.3705 5.44531H73.4665L74.219 31.6453H69.317Z",
    fill: "#1B1028"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7629 14.5118V31.6451H91.5919L91.4199 29.2896C90.1944 30.8451 88.3884 31.9785 85.9374 31.9785C81.3579 31.9785 77.9609 28.134 77.9609 23.0674C77.9609 18.0007 81.4654 14.1562 86.0449 14.1562C88.2379 14.1562 89.9794 14.9785 91.2049 16.134L91.4199 14.4896H95.7629V14.5118ZM91.2264 23.0896C91.2264 20.4896 89.5709 18.6229 86.9694 18.6229C84.5614 18.6229 82.7124 20.5118 82.7124 23.0896C82.7124 25.6229 84.5399 27.5562 86.9694 27.5562C89.5709 27.5562 91.2694 25.6674 91.2264 23.0896Z",
    fill: "#1B1028"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 5.04688H114.23V31.6469H109.5V5.04688Z",
    fill: "#1B1028"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M132.827 27.5562V31.6451H117.82V28.0228L126.614 18.6006H118.143V14.5117H132.634V18.1339L123.84 27.5562H132.827Z",
    fill: "#1B1028"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.544 27.5562V31.6451H135.559V28.0228L144.352 18.6006H135.881V14.5117H150.372V18.1339L141.579 27.5562H150.544Z",
    fill: "#1B1028"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M164.433 30.9562L161.251 38.9117H156.607L159.38 31.6006L152.307 14.5117H157.596L161.853 26.0673L166.024 14.5117H170.883L164.433 30.9562Z",
    fill: "#1B1028"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.578 14.6673C102.492 14.8006 102.406 14.9117 102.298 15.0451C102.212 15.1562 102.04 15.1562 101.976 15.0228C101.954 15.0006 101.954 14.9562 101.954 14.9339C101.954 14.8006 101.954 14.6451 101.954 14.5117H100.256V31.6451H104.986V14.5117H102.664C102.642 14.5784 102.599 14.6228 102.578 14.6673Z",
    fill: "#1B1028"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15666_2579",
    x1: 1.20627,
    y1: 20.4728,
    x2: 41.3753,
    y2: 20.4728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#C11D85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4805,
    stopColor: "#5A3C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8101,
    stopColor: "#1C0F24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15666_2579",
    x1: 4.37746,
    y1: 10.4695,
    x2: 8.57094,
    y2: 2.09211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027962,
    stopColor: "#E31F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15666_2579",
    x1: 14.5443,
    y1: 12.502,
    x2: 7.71462,
    y2: 1.05721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C449B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15666_2579",
    x1: 36.8555,
    y1: 11.8859,
    x2: 36.8555,
    y2: 5.06017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027962,
    stopColor: "#1C0F24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSideNavMailzzyLogo);
export default __webpack_public_path__ + "static/media/light_side_nav_mailzzy_logo.7f72df79b1ebce5ef39c1eb618cd1295.svg";
export { ForwardRef as ReactComponent };